module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-flyer.36c7a861.jpg";